import { Image } from "../shared/index";
import styles from "./featuredbanner.module.css";

const FeaturedBanner = () => {
  return (
    <section className={styles.featuredbanner__wrapper}>
      <div className={styles.image_container}>
        <Image
          src={"/assets/img/collections/Background.png"}
          alt="left-img"
          className={styles.image}
        />
        <Image
          src={"/assets/img/collections/Background-1.png"}
          alt="right-img"
          className={styles.image}
        />
      </div>
    </section>
  );
};

export default FeaturedBanner;